































































































































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import CreateRelation from '@/components/CreateRelation/index.vue'
import { formatDate, httpsImg } from '@/utils/tool'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { quotes, unbind } from '@/api/relation'

import toB2cUrl from '@/utils/toB2cUrl'

@Component({
  name: 'ProductList',
  components: {
    CreateRelation
  }
})
export default class ProductList extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  loading!: boolean

  // 是否是美食产品
  @Prop({
    type: Boolean,
    default: false
  })
  isFood?: boolean

  /**
   * @param {Array} list 列表数据
   * @description: 数组类型数据
   */
  @Prop({
    type: Array,
    default: () => []
  })
  list!: Array<any>

  /**
   * @param {String} type 列表类型
   * @description: 可选 card 默认为空
   */
  @Prop({
    type: String,
    default: ''
  })
  type!: '' | 'card'

  private readonly treeIdName = {
    0: '门票',
    1: '套餐',
    2: '自由行',
    3: '线路',
    4: '演出',
    5: '住宿',
    6: '服务',
    7: '租车',
    8: '签证',
    9: '邮轮',
    10: '机票',
    11: '商品',
    12: '抢购',
    13: '租车（新）',
    14: '交通',
    15: '场馆',
    16: '培训课程',
    17: '户外装备',
    18: 'OMO服务'
  }

  // 需要办的的数据
  private bindData: any = {}

  // 绑定分销商弹框
  private createShow = false

  private httpsImg = httpsImg

  private get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  private get listData () {
    const arr = this.list.map(item => {
      if (item.treeId === 12) {
        item.treeIdNameColor = 'linear-gradient(90deg, #FA6D0F, #F73434)'
      }
      item.systemGrade = String(item.systemGrade || '')
      item.treeIdName = this.treeIdName[item.treeId]
      item.star = (item.systemGrade / 2) || 0
      item.priceStartDateStr = formatDate(item.priceStartDate, 'Y-M-D')
      item.priceEndDateStr = formatDate(item.priceEndDate, 'Y-M-D')
      // 处理 产品绑定关系
      if (item.refStatus === 3) {
        // 可操作 绑定关系
        item.btnClassName = 'list_3'
      } else if (item.refStatus === 0 && item.cmProdLog) {
        // 可操作 取消引用
        item.btnClassName = 'list_2'
      } else if (item.refStatus === 0 && !item.cmProdLog) {
        // 可操作 引用产品
        item.btnClassName = 'list_1'
      }

      return item
    })
    return arr
  }

  // 绑定关系 弹框显示
  private clickBind (item) {
    this.bindData = item
    this.createShow = true
  }

  // 绑定成功通知
  @Emit('bind')
  private clickFastCreate (): any {
    return ''
  }

  // 引用产品
  private clickQuote (item): void {
    const data = {
      dbLink: item.dbLink,
      infoId: item.infoId,
      parentMchId: item.parentMchId
    }
    quotes(data).then(res => {
      if (res.success) {
        this.$message({
          type: 'success',
          message: res.msg
        })
        this.handleQuote()
      } else {
        this.$message({
          type: 'error',
          message: res.msg
        })
      }
    })
  }

  // 引用成功通知
  @Emit('quote')
  private handleQuote () {
    console.log("@Emit('quote')")
    return ''
  }

  // 取消引用
  private clickUnbind (item): void {
    const data = {
      dbLink: item.dbLink,
      infoId: item.infoId,
      newInfoId: item.cmProdLog.newInfoId,
      parentMchId: item.parentMchId
    }
    unbind(data).then(res => {
      if (res.success) {
        this.$message({
          type: 'success',
          message: '取消引用成功!'
        })
        this.handleUnbind()
      } else {
        this.$message({
          type: 'error',
          message: res.msg
        })
      }
    })
  }

  // 取消引用成功 回调
  @Emit('unbind')
  private handleUnbind () {
    return ''
  }

  // 跳转 到对方主页
  private clickMchName (item) {
    const url = `/business/merchant/${item.dbLink}/${item.parentMchId}`
    if (this.$route.fullPath === url) return false
    this.$router.push(url)
  }

  // 跳转到 b2c 页面
  private clickTitle (item, e) {
    toB2cUrl(item, e.screenX, e.screenY)
  }
}
